import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { SERVICE_AREAS } from '../../data/siteData';
import { MapPin } from 'lucide-react';

export default function ServiceAreas() {
  const { t } = useLang();
  return (
    <section className="bg-[#12151A] py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{t.areas.label}</span>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mt-3 font-outfit">{t.areas.heading}</h2>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {SERVICE_AREAS.map(area => (
            <div key={area} className="flex items-center gap-2 bg-[#0B0D0F] border border-white/8 px-4 py-2.5 rounded-full">
              <MapPin className="w-3.5 h-3.5 text-[#D4AF37]" /><span className="text-white text-sm">{area}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
